module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJmb250cy9nbHlwaGljb25zLWhhbGZsaW5ncy1yZWd1bGFyLTg5ODg5Ni5zdmciOw=="


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.svg
// module id = 793
// module chunks = 2